type RegexPatterns = {
    [key: string]: RegExp
}

type Validations = {
    [key: string]: {
        defaultMessage?: string
        invalidPatterns?: {regExp: RegExp, message: string}[],
        requiredPatterns?: {regExp: RegExp, message: string}[],
        matchPattern?: RegExp,
        required?: boolean
    }
}

const regexPatterns: RegexPatterns = {
    isHTML: new RegExp('(<([^>]+)>)'),
    isURL: new RegExp('(telnet|ftp|https?):\/\/(?:[a-z0-9][a-z0-9-]{0,61}[a-z0-9]\.|[a-z0-9]\.)+[a-z]{2,63}'),
    validEmail: new RegExp('^([^@\\s]+)@((?:[-a-z0-9]+\\.)+[a-z]{2,})$', 'i'),
    phoneNumber: new RegExp('^\\+?[0-9\\s\\-]+$'),
    // >= 10 characters long, at least 1 uppercase, at least 1 number, at least one special character
    isValidPassword: new RegExp('^(?=(.*[A-Z]))(?=(.*\\d))(?=(.*[!@#$%^&*(),.?":{}|<>+=/\\-_]))[A-Za-z0-9!@#$%^&*(),.?":{}|<>+=/\\-_]{10,}$'),
    hasMinimumChars: new RegExp('.{10,}'),
    hasUpperCase: new RegExp('[A-Z]'),
    hasNumber: new RegExp('\\d'),
    hasSpecialChar: new RegExp('[!@#$%^&*(),.?":{}|<>+=/\\-_]')
};

const errorMessages = {
    noHTML: 'Value must not contain any HTML',
    noURLs: 'Value must not contain any URLs'
};

export const formValidations: Validations = {
    email: {
        invalidPatterns: [
            { regExp: regexPatterns.isHTML, message: errorMessages.noHTML },
        ],
        matchPattern: regexPatterns.validEmail,
        defaultMessage: "A valid email address is required",
    },
    text: {
        invalidPatterns: [
            { regExp: regexPatterns.isHTML, message: errorMessages.noHTML },
            { regExp: regexPatterns.isURL, message: errorMessages.noURLs },
        ],
        defaultMessage: "Value contains disallowed characters",
    },
    tel: {
        matchPattern: regexPatterns.phoneNumber,
        defaultMessage: "Please enter a valid phone number"
    },
    password: {
        invalidPatterns: [
            { regExp: regexPatterns.isHTML, message: errorMessages.noHTML },
            { regExp: regexPatterns.isURL, message: errorMessages.noURLs },
        ],
        requiredPatterns: [
            { regExp: regexPatterns.hasMinimumChars, message: 'Password must be at least 10 characters long' },
            { regExp: regexPatterns.hasUpperCase, message: 'Password must contain at least one uppercase letter' },
            { regExp: regexPatterns.hasNumber, message: 'Password must contain at least one number' },
            { regExp: regexPatterns.hasSpecialChar, message: 'Password must contain at least one special character' },
        ],
        // matchPattern: regexPatterns.isValidPassword,
        // defaultMessage: "Password must be at least 10 characters long, with at least one lowercase letter, one uppercase letter, one number, and one special character."
    }
};
